export default __webpack_public_path__ + "static/dealer1-f78311686d773cde00354312f91bf793.svg";